module.exports = __webpack_public_path__ + "static/yagnoloth-4edbef4e483b5e6d71805b0e2c376207.png";